import { createModalsComponent } from 'modules/campaigns/lib';
import { NoOpComponent } from 'utils/reactHelpers';
import { useModalContext, ModalType, ModalProps } from '../contexts/ModalContext';
import { CreateGoalModal } from '../lib/components/CreateGoalModal/CreateGoalModal';

const GOALS_PAGE_MODAL_COMPONENTS_MAPPER = {
  [ModalType.None]: NoOpComponent,
  [ModalType.CreateGoalModal]: CreateGoalModal,
};

export const Modals = createModalsComponent<ModalType, ModalProps>(
  GOALS_PAGE_MODAL_COMPONENTS_MAPPER,
  useModalContext,
);
